import React from 'react';

import cn from 'classnames';

// styles
import css from './card.css';

type Props = {
    id?: string;
    titleStyles?: string;
    scrollRef?: React.Ref<HTMLDivElement>;
    wideContent?: boolean;
    title?: string;
    secondTitle?: React.ReactNode;
    dataQa?: string;
    className?: string;
};

const Card: React.FC<React.PropsWithChildren<Props>> = (props) => (
    <div
        id={props.id}
        ref={props.scrollRef}
        className={cn(css.root, props.className)}
        data-qa={props.dataQa}
    >
        <div
            className={cn(css.content, {
                [css.contentWide]: props.wideContent,
            })}
        >
            {props.title && (
                <div className={cn(css.title, props.titleStyles)}>
                    {props.title}
                    {props.secondTitle && (
                        <span className={css.secondTitle}>
                            {props.secondTitle}
                        </span>
                    )}
                </div>
            )}
            {props.children}
        </div>
    </div>
);

export default Card;
